import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutFmDataOutputTable extends Layout {
    sourceFreightMatchingDataOutput: DataSource;
    tableFmDataOutput: Table;
}
